import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { Request } from "../models/request.model";
import { Attachement } from "../models/attachement.model";

let httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

@Injectable()
export class RequestService {
    private requestsUrl = environment.api + "Requests/"
    private request: Request = new Request();

    constructor(private http:HttpClient) {}
    public putRequest(request: Request): Observable<Request>{
      return this.http
      .put<Request>(this.requestsUrl + request.id, request, httpOptions)
      .pipe(catchError(this.handleError));
    }
    public postRequest(request: Request): Observable<Request> {
        return this.http
            .post<Request>(this.requestsUrl, request, httpOptions)
            .pipe(catchError(this.handleError));
    }

    public getRequestById(requestId: string): Observable<Request>{
      console.log(this.requestsUrl + requestId);
      return this.http
            .get<Request>(this.requestsUrl + requestId, httpOptions)
            .pipe(catchError(this.handleError));
    }

    public getRequestStatusById(requestId: string): Observable<Request>{
      console.log(this.requestsUrl + "status/" + requestId);
      return this.http
            .get<Request>(this.requestsUrl + "status/" + requestId, httpOptions)
            .pipe(catchError(this.handleError));
    }


    public setRequest(request: Request) {
        this.request = request;
    }

    public getRequest() {
        return this.request;
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.error("Fout:", error.error.message);
        } else {
          console.error(
            `Backend returned code Deze code voor handling ${error.status}` +
              ` body was: ${error.error}`
          );
        }
    
        return throwError("Something went wrong");
      }
}